import React from "react";
import "./css/home.css";

const HomePage = () => {
  return (
    <div>
      <h1>
        ONE STOP SOLUTION <br /> FOR GIVING YOUR ATTENDANCE <br /> JUST TURN ON
        YOUR LOCATION AND GIVE YOUR ATTENDANCE{" "}
      </h1>
    </div>
  );
};

export default HomePage;
